import React from 'react'
import PropTypes from 'prop-types'

// A neutral label for one split part; only the dot carries its color, matching the outline on its pages.
const SegmentBadge = ({ color, children }) => (
  <span className="d-inline-flex align-items-center gap-1 border rounded-pill bg-white text-body px-2 small text-nowrap">
    <span className={`rounded-circle bg-${color} flex-shrink-0`} style={{ width: 8, height: 8 }} aria-hidden="true" />
    {children}
  </span>
)

SegmentBadge.propTypes = {
  color: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default SegmentBadge
